import React, { useEffect, useState } from 'react'
import { client } from '_services'
import { _global } from '../../utils/global'

const RowExpandTitle = (titleProps: any) => {
  return <div className="reportsId mt-10">{titleProps.children}</div>
}

const PracticeReportExpandedRow: React.FC<any> = props => {
  const { address, phone, email } = props
  const { address1, address2, city, state, zip } = address
  const [loaded, setLoaded] = useState(false)
  const [doctorInfo, setDoctorInfo] = useState<any>({})

  useEffect(() => {
    client
      .getProvidersFetch({
        npi: props.NPI,
        key: props.doctorKey,
        allowTerminated: true,
        allowUnpublished: true,
      })
      .then((response: any) => {
        setDoctorInfo(response[0])
        setLoaded(true)
      })
      .catch((error: any) => {
        console.error('Error fetching provider:', error)
      })
  }, [props.doctorKey, props.NPI])

  return (
    <div className="practice-report-row-expand">
      <div>
        <RowExpandTitle>MEMBER ADDRESS</RowExpandTitle>
        <div>{address1}</div>
        <div>{address2}</div>
        <div>{`${city}, ${state} ${zip}`}</div>
        <RowExpandTitle>MEMBER EMAIL</RowExpandTitle>
        <div>{email}</div>
      </div>
      <div className="member-phone">
        <RowExpandTitle>MEMBER PHONE</RowExpandTitle>
        <div>{phone && _global.formatNumber(phone)}</div>
      </div>
      {props.status !== 'Terminated' && loaded && !!doctorInfo && (
        <div>
          <RowExpandTitle>PRACTICE NAME</RowExpandTitle>
          <div>{doctorInfo.practiceName}</div>
          <RowExpandTitle>PRACTICE LOCATION</RowExpandTitle>
          {doctorInfo.virtualOption === 'Only' ? (
            <div>Virtual only</div>
          ) : (
            <>
              <div>{doctorInfo.billingAddress1}</div>
              <div>{doctorInfo.billingAddress2}</div>
              <div>
                {`${doctorInfo.billingCity}, ${doctorInfo.billingState} ${doctorInfo.billingZipCode}`}
              </div>
            </>
          )}
        </div>
      )}
    </div>
  )
}

export default PracticeReportExpandedRow
